(function() {
    "use strict";

    /**
     * google tagmanager for collecting input values for insertion on specific datalayer keys
     *
     */
    ZZ.GtmTouchpointCollect = function(GtmTouchpointCollectContainer) {
        var base = this;

        if (typeof jQuery != "undefined") {
            base.container = GtmTouchpointCollectContainer.get(0);
        } else {
            base.container = GtmTouchpointCollectContainer;
        }

        base.inputValuesToDatalayerValues = JSON.parse(
            base.container.getAttribute(
                "data-gtm-collect-inputvalues-to-datalayer"
            )
        );
        base.datalayerData = JSON.parse(
            base.container.getAttribute("data-gtm-collect-datalayer")
        );
        base._eventsToBind = base.container.getAttribute("data-gtm-event");

        base.init();
    };

    ZZ.GtmTouchpointCollect.prototype = {
        init: function() {
            const base = this;

            if (base.isNotEmpty(base._eventsToBind)) {
                for (let event of base.eventsList(base._eventsToBind)) {
                    base.addEventDataListener(event);
                }
            } else {
                base.addEventDataListener("click");
            }
        },

        addEventDataListener: function(event) {
            const base = this;

            base.container.addEventListener(event, base.pushData.bind(this));
        },

        collectInputValuesIntoDatalayer: function() {
            const base = this;

            if (base.inputValuesToDatalayerValues.length > 0) {
                for (let target of base.inputValuesToDatalayerValues) {
                    let elementTarget = document.querySelector(
                        target.elementTarget
                    );
                    if (elementTarget !== null) {
                        let elementTargetValue = elementTarget.value;

                        if (
                            base.isNotEmpty(elementTargetValue) &&
                            base.isNotEmpty(target.dataLayerTarget)
                        ) {
                            base.setObjectNestedProperty(
                                target.dataLayerTarget,
                                elementTargetValue
                            );
                        }
                    }
                }
            }
        },

        // Schema is a moving reference to internal objects within the datalayerData
        setObjectNestedProperty: function(path, value) {
            const base = this;

            let schema = base.datalayerData;
            let pList = path.split(".");
            let len = pList.length;
            for (let i = 0; i < len - 1; i++) {
                let elem = pList[i];
                if (!schema[elem]) schema[elem] = {};
                schema = schema[elem];
            }

            schema[pList[len - 1]] = value;
        },

        isNotEmpty: function(value) {
            return value !== undefined && value !== null && value !== "";
        },

        eventsList: function(dataGtmEvent) {
            const parsedGtmEvent = dataGtmEvent.replace(
                /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                ""
            );

            return parsedGtmEvent.split(",");
        },

        pushData: function(e) {
            const base = this;

            base.collectInputValuesIntoDatalayer();

            if (window["dataLayer"]) {
                window["dataLayer"].push(base.datalayerData);
            }
        }
    };
})();
